import React from "react";
import CuentaHeader from "./CuentaHeader";
import { Container } from "semantic-ui-react";
import CuentaList from "./CuentaList";
import PropTypes from "prop-types";
import CuentaListEmpty from "./CuentaListEmpty";

const CuentaDashboard = ({ cuentas }) => {
  return (
    <Container className="containerPrincipal">
      <CuentaHeader />
      {cuentas && cuentas.length > 0 ? (
        <CuentaList cuentas={cuentas} />
      ) : (
        <CuentaListEmpty />
      )}
    </Container>
  );
};

CuentaDashboard.propTypes = {
  cuentas: PropTypes.array.isRequired,
};
export default CuentaDashboard;
